"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var _ = require("underscore");
require("./searchField.less");
var SearchField = /** @class */ (function (_super) {
    __extends(SearchField, _super);
    function SearchField(props) {
        var _this = _super.call(this, props) || this;
        _this.searchInputChanged = function (e) {
            if (_this.props.disabled)
                return;
            _this.setState({
                searchText: e.currentTarget.value
            }, _this.triggerCallbackDebounced);
        };
        _this.clearInput = function () {
            if (_this.props.disabled)
                return;
            _this.setState({
                searchText: ''
            }, _this.triggerCallbackDebounced);
        };
        _this.triggerCallback = function () {
            _this.props.searchTextChanged(_this.state.searchText);
        };
        _this.state = {
            searchText: props.initialSearchText || ''
        };
        /* note: defaultProps will ensure this is not undefined */
        var debounceTime = _this.props.debounceTime;
        _this.triggerCallbackDebounced = debounceTime > 0
            ? _.debounce(_this.triggerCallback, debounceTime)
            : _this.triggerCallback;
        return _this;
    }
    SearchField.prototype.render = function () {
        var _this = this;
        var containerClass = "outer-search-container" + (this.state.searchText ? ' filtered' : '');
        return (React.createElement("div", { className: containerClass, style: { width: '100%' } },
            React.createElement("span", { className: 'field-clear', title: 'Clear', onClick: this.clearInput }),
            React.createElement("input", { type: 'text', value: this.state.searchText, className: 'search-field-input', placeholder: this.props.placeholderText, style: { width: '100%' }, onChange: this.searchInputChanged, disabled: this.props.disabled, role: "searchbox", ref: function (ref) { _this.input = ref; } })));
    };
    SearchField.prototype.componentDidMount = function () {
        var input = this.input;
        if (input && this.props.autoFocus)
            requestAnimationFrame(function () { return input.focus(); });
    };
    SearchField.defaultProps = {
        debounceTime: 500
    };
    return SearchField;
}(React.PureComponent));
exports.SearchField = SearchField;
